import { render, staticRenderFns } from "./DrawPoint.vue?vue&type=template&id=6d9f06dc&scoped=true"
import script from "./DrawPoint.vue?vue&type=script&lang=js"
export * from "./DrawPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f06dc",
  null
  
)

export default component.exports